import { Injectable, InjectionToken, inject } from '@angular/core';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { isEmpty } from 'lodash';

export const CoreMediaService = new InjectionToken<MediaService>(
  'CoreMediaService'
);

@Injectable()
export class MediaService {
  private api = inject(CommonVerbsApiService);
  async getBase64Image(url: string) {
    return new Promise((resolve, reject) => {
      if (isEmpty(url)) {
        resolve(null);
      }
      this.api.post('media/encode-image', { url: url }).subscribe(next => {
        resolve(next);
      });
    });
  }
}
